import React, { useState } from "react";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";
import LeftMenuContainer from "./leftMeuContainer";
import RightContent from "./rightContent";

const Layout = (props) => {

     const [expand, setExpand] = useState(false);
        
    const handleExpand = () => {
        setExpand(!expand);
    }

    return(
        <div className={classes.layout_container}>
            <LeftMenuContainer expand={expand} handleExpand={handleExpand} />
            <RightContent expand={expand} handleExpand={handleExpand} >{props.children}</RightContent>
        </div>
    )
}

Layout.propTypes = {
    children: PropTypes.node,
};

export default Layout;